module.exports = __webpack_public_path__ + "static/heroMedium.eea7b092.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Img/Hero/heroMedium.jpg
// module id = 353
// module chunks = 213534597649335